export abstract class ModalComponent {
    static MODAL_ID: string;

    abstract getId(): string;
}
